import { MilitaryTechOutlined } from "@mui/icons-material";

const achievementAwardResource = {
    title: "Achievement Awards",
    singular: "Achievement Award",

    collectionField: "achievementAwards",

    displayField: "description",
    icon: MilitaryTechOutlined,

    columns: [
        {
            field: "description",
            header:
                "Non-Academic Distinction Recognition\n" + "(Write in Full)",
            type: "text"
        },
        {
            field: "awardDate",
            header: "Award Date",
            type: "date"
        },
        {
            field: "awardedBy",
            header: "Given By",
            type: "text"
        }
    ],

    fields: {
        description: {
            name: "description",
            label: "Non-Academic Distinction Recognition\n" + "(Write in Full)",
            type: "text",
            required: true
        },
        awardDate: {
            name: "awardDate",
            label: "Award Date",
            type: "date",
            required: true
        },
        awardedBy: {
            name: "awardedBy",
            label: "Given By",
            type: "text"
        }
    }
};

export default achievementAwardResource;
